import { loader as http, webviewInfo } from '@ali/amap-lib';
import Vue from 'vue';
import {
  install as installMap,
} from '@ali/amap-traffic-brain-fe-common-map';
import api from '../../../../config/config.aos';
import registerCustomLayers from './mapLayer/index';

export default {
  data() {
    return {
      realTimeData: {}, // 实时拥堵
      congestDataList: [], // 拥堵列表，用于地图展示
      congestDataInited: false,
      updateTime: null, // 更新时间
      cityAdcode: '',
      unitId: null,
      areaType: null,
      isError: false,
      predictData: null,
      cityName: '',
      mapLoaded: false
    };
  },
  methods: {
    async getUnitData(info) {
      console.log('info', info);
      if (info && info.unitId) {
        this.unitId = info.unitId || null;
        this.areaType = info.areaType;
        this.cityAdcode = info.cityAdcode || info.adcode;
        this.cityName = info.cityName;
        this.getCongestData();
        this.getHomeData();
        return true;
      }
    },
    $request({ url, params }) {
      return new Promise((reslove, reject) => {
        const request = webviewInfo.isInAmap() ? http.post : http.jsonp;
        request(
          url,
          params,
          (res) => {
            console.log('response', res);
            if (Number(res.code) === 1) {
              reslove(res.data);
            } else {
              reject(res);
            }
          }
        );
      });
    },
    async getHomeData() {
      // const needSignParams = ['unitId', 'adcode', 'unitName'];
      this.isError = false;
      const homeData = await this.$request({
        url: api.homePageList,
        params: [
          {
            unitId: this.unitId,
            sign: 1
          },
          {
            areaType: this.areaType
          }
        ]
      }).catch((error) => {
        console.error('error', error);
        this.isError = true;
        return false;
      });
      this.updateTime = null;
      this.realTimeData = null;
      if (!homeData) return false;
      if (homeData && this.unitId && this.areaType !== null) {
        const {
          realTime, updateTime, predict, hot, history, information, operation
        } = homeData;
        this.realTimeData = realTime || null;
        this.updateTime = updateTime;
        this.predictData = {
          predict,
          hot
        };
        this.historyData = history || null;
        this.helpNum = operation && operation.helpPeople && Number(operation.helpPeople);
        this.information = information || null;
      }
      return true;
    },
    // 获取拥堵数据
    async getCongestData() {
      this.isError = false;
      const result = await this.$request({
        url: api.congestList,
        params: [
          {
            unitId: this.unitId,
            sign: 1
          },
          {
            areaType: this.areaType
          }
        ]
      }).catch((error) => {
        console.error('error', error);
        this.isError = true;
        return false;
      });
      if (!result) return false;
      const { list } = result || [];
      list.forEach((item, index) => {
        item.id = index;
      });
      this.congestDataList = list;
      this.congestDataInited = true;
      return true;
    },
    async loadMap() {
      await installMap(Vue);
      registerCustomLayers();
      this.mapLoaded = true;
    },
  }
};
